import React, { useEffect, useRef, useState } from "react";
import { MapProvider } from "../../contexts/map";

import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";

interface MapProps {
  accessToken: string;
  options?: {
    center?: [number, number];
    zoom?: number;
    style?: string;
    maxZoom?: number;
  };
}

const Map: React.FC<MapProps> = ({ accessToken, options = {}, children }) => {
  const [map, setMap] = useState<mapboxgl.Map | null>(null);
  const container = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const attachMap = (
      setMap: React.Dispatch<React.SetStateAction<any>>,
      container: React.RefObject<HTMLDivElement>
    ) => {
      if (!container.current) {
        return;
      }
      const map = new mapboxgl.Map({
        container: container.current,
        ...options,
        accessToken,
      });

      map.on("load", () => {
        setMap(map);
      });
    };

    !map && attachMap(setMap, container);

    return () => {
      if (map) {
        map.remove();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex h-full relative">
      <div className="h-full flex-grow rounded-lg" ref={container} />
      {map && (
        <MapProvider accessToken={accessToken} map={map} setMap={setMap}>
          {children}
        </MapProvider>
      )}
    </div>
  );
};

export default Map;
